export function getDeepFromObject(object: unknown, path: string, defaultValue?: unknown): unknown {
	if (!object || !path) {
		return defaultValue;
	}
	const keys = path.split('.');
	let result: unknown = object;
	for (const key of keys) {
		if (result == null || typeof result !== 'object') {
			return defaultValue;
		}
		result = (result as Record<string, unknown>)[key];
	}
	return result === undefined ? defaultValue : result;
}
